import skip from "../skip.png";

export default function Footer({ windowDimensions }) {
  return (
    <div style={styles.container}>
      <img
        src={skip}
        style={
          windowDimensions.width < 1000
            ? { height: windowDimensions.width / 10 }
            : { height: windowDimensions.width / 25 }
        }
      />
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
  },
};
